<template>
    <div class="container">
        <div class="content">
            <h1 class="product-name">{{detail.name}}</h1>
            <div class="user-wrap">
                <img :src="profile.avatar|default_img" alt="" class="avatar" @click="go2user">
                <p class="realname">{{profile.realname}}</p>
                <p class="address">{{profile.province}}{{profile.city}}{{profile.zone}}</p>
            </div>

            <div class="main">
                <div class="info">
                    <img :src="detail.image|default_img" alt="" class="left">
                    <div class="right">
                        <div class="title">Basic Information</div>
                        <div class="list1">
                            <div class="item1">
                                <div class="key">Product Category</div>
                                <div class="value">{{detail.product_category_name}}</div>
                            </div>
                            <div class="item1">
                                <div class="key">Applicable Gender</div>
                                <div class="value"></div>
                            </div>
                            <div class="item1" style="width: 480px;">
                                <div class="key">Product Description</div>
                                <div class="value">{{detail.description}}</div>
                            </div>
                        </div>
                        <div class="title">Parameter Information</div>
                        <div class="table">
                            <div class="item" v-for="(v,k) in detail.param" :key="`p`+k">
                                <div class="th">{{v.key}}</div>
                                <div class="td">{{v.value}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="title">Detailed Description</div>
                <div class="richtext" v-html="detail.detail"></div>
            </div>

        </div>

    </div>
</template>

<script>
    import {
        GetProduct,
        ProfileNoAuth
    } from "@/api/index.js";
    export default {
        name: "ProductDetail",
        components: {},
        data() {
            return {
                uuid: '',
                detail: {},
                profile: {}
            };
        },

        computed: {},
        methods: {
            go2user() {
                this.$router.push({name: 'ShopHome', query: {uid: this.detail.code}})
            },
            async getProfile(code) {
                return ProfileNoAuth({code}).then((response) => {
                    this.profile = response.data
                    return response;
                });
            },
            async getProduct() {
                this.$Spin.show();
                GetProduct({
                    uuid: this.uuid,
                }).then((response) => {
                    this.detail = response.data
                    return this.getProfile(this.detail.code)
                }).finally(() => {
                    this.$Spin.hide();
                });
            },
        },
        mounted() {
            this.uuid = this.$route.query.uuid
            this.getProduct()
        }
    };
</script>

<style lang="scss" scoped>
    .container {
        background: #f6f7fa;
        padding: 30px 0 150px 0;
        display: flex;
        justify-content: center;

        .content {
            width: 1060px;
            padding: 30px;
            background: white;

            .product-name {
                color: #1A1A1A;
                font-size: 30px;
            }

            .user-wrap {
                margin-top: 40px;
                position: relative;
                .avatar {
                    width: 55px;
                    height: 55px;
                    border-radius: 50%;
                    cursor: pointer;
                }
                .realname {
                    position: absolute;
                    top: 0;
                    left: 80px;
                    font-size: 16px;
                    color: black;
                }
                .address {
                    position: absolute;
                    top: 30px;
                    left: 80px;
                    font-size: 12px;
                    color: #A2A4A3;
                }
            }

            .title {
                height: 20px;
                line-height: 20px;
                font-size: 16px;
                border-left: 3px solid #fa3d5a;
                padding-left: 8px;
                margin: 20px 0;
                color: #1A1A1A;
            }

            .info {
                display: flex;
                flex-wrap: nowrap;
                justify-content: space-between;
                .left {
                    width: 480px;
                    height: 480px;
                }
                .right {
                    width: 480px;
                    .list1 {
                        display: flex;
                        flex-wrap: wrap;
                        align-items: center;
                        .item1 {
                            width: 238px;
                            height: 48px;
                            display: flex;
                            align-items: center;
                            border-top: 2px solid #f5f5f5;
                            .key {
                                width: 80px;
                                color: #666666;
                                font-size: 14px;
                                font-weight: bold;
                            }
                            .value {
                            }
                        }
                    }

                    .table {
                        display: flex;
                        flex-wrap: wrap;
                        align-items: center;
                        border: 1px solid #f5f5f5;
                        .item {
                            width: 238px;
                            display: flex;
                            align-items: center;
                            border-top: 2px solid #f5f5f5;
                            .th {
                                width: 80px;
                                height: 42px;
                                line-height: 42px;
                                color: #666666;
                                font-size: 14px;
                                font-weight: bold;
                                background: #f5f5f5;
                                text-align: center;
                            }
                            .td {
                                padding-left: 20px;
                                height: 42px;
                                line-height: 42px;
                            }
                        }
                    }
                }
            }
        }

    }
</style>
